import {
  Autocomplete,
  Box,
  Button,
  Chip,
  Paper,
  Stack,
  TextField,
  ToggleButton,
  ToggleButtonGroup,
  Typography,
} from "@mui/material";
import Iconify from "../../../components/iconify";

export default function ShopCatalogMemberHeader({
  isMobileViewport,
  isMyOrdersView,
  catalogProductsCount,
  totalCatalogProductsCount,
  myOrdersCount,
  hasLivePromotion,
  loadingMyOrders,
  fetchingMyOrders,
  memberCatalogLayout,
  categoryOptions = [],
  selectedCategories = [],
  onShowCatalog,
  onShowOrders,
  onLayoutChange,
  onCategoryChange,
}) {
  const orderChipLabel =
    loadingMyOrders || fetchingMyOrders
      ? "Bestellungen laden..."
      : `${myOrdersCount} Bestellung${myOrdersCount === 1 ? "" : "en"}`;
  const productChipLabel =
    totalCatalogProductsCount > catalogProductsCount
      ? `${catalogProductsCount} von ${totalCatalogProductsCount} Produkten`
      : `${catalogProductsCount} Produkt${
          catalogProductsCount === 1 ? "" : "e"
        }`;

  return (
    <Box sx={{ mb: 2 }}>
      <Paper
        variant="outlined"
        sx={{
          p: { xs: 1.1, sm: 1.5 },
          borderRadius: 2.25,
          background:
            "linear-gradient(135deg, rgba(59,130,246,0.06) 0%, rgba(16,185,129,0.06) 100%)",
        }}
      >
        <Stack spacing={0.9}>
          <Stack
            direction="row"
            spacing={1}
            alignItems="flex-start"
            justifyContent="space-between"
          >
            <Box sx={{ minWidth: 0, flexGrow: 1 }}>
              <Typography
                variant="subtitle1"
                fontWeight={700}
                sx={{
                  lineHeight: 1.2,
                  fontSize: { xs: "0.98rem", sm: "1.08rem" },
                }}
              >
                Dein Shopbereich
              </Typography>
              <Typography
                variant="body2"
                color="text.secondary"
                sx={{ mt: 0.25, lineHeight: 1.45 }}
              >
                {isMyOrdersView
                  ? "Status und Rechnungen schnell einsehen."
                  : "Produkte schneller finden und direkt bestellen."}
              </Typography>
            </Box>

            <Button
              size="small"
              variant={isMyOrdersView ? "contained" : "outlined"}
              onClick={isMyOrdersView ? onShowCatalog : onShowOrders}
              startIcon={
                <Iconify
                  icon={
                    isMyOrdersView
                      ? "eva:arrow-back-fill"
                      : "eva:file-text-outline"
                  }
                  width={16}
                />
              }
              sx={{ flexShrink: 0 }}
            >
              {isMyOrdersView
                ? isMobileViewport
                  ? "Katalog"
                  : "Zum Katalog"
                : isMobileViewport
                ? "Bestellungen"
                : "Meine Bestellungen"}
            </Button>
          </Stack>

          <Stack
            direction="row"
            spacing={0.75}
            flexWrap="wrap"
            useFlexGap
            alignItems="center"
          >
            <Chip
              size="small"
              color="primary"
              variant="outlined"
              label={orderChipLabel}
            />
            {!isMyOrdersView ? (
              <Chip size="small" variant="outlined" label={productChipLabel} />
            ) : null}
            {!isMyOrdersView
              ? selectedCategories.map((category) => (
                  <Chip
                    key={category}
                    size="small"
                    color="primary"
                    variant="outlined"
                    label={`Kategorie: ${category}`}
                  />
                ))
              : null}
            {!isMyOrdersView && hasLivePromotion ? (
              <Chip
                size="small"
                color="error"
                variant="outlined"
                label="Aktionen aktiv"
              />
            ) : null}
          </Stack>
        </Stack>
      </Paper>

      {!isMyOrdersView ? (
        <Stack
          direction={{ xs: "column", sm: "row" }}
          spacing={1}
          alignItems={{ xs: "stretch", sm: "center" }}
          justifyContent="space-between"
          sx={{ mt: 1 }}
        >
          <ToggleButtonGroup
            exclusive
            size="small"
            value={memberCatalogLayout}
            onChange={onLayoutChange}
            aria-label="Ansicht für den Shopkatalog"
          >
            <ToggleButton
              value="list"
              aria-label="Listenansicht"
              sx={{
                gap: isMobileViewport ? 0 : 0.5,
                px: isMobileViewport ? 1.1 : 1.4,
                textTransform: "none",
              }}
            >
              <Iconify icon="mdi:view-list-outline" width={17} />
              {!isMobileViewport ? "Liste" : null}
            </ToggleButton>
            <ToggleButton
              value="cards"
              aria-label="Kartenansicht"
              sx={{
                gap: isMobileViewport ? 0 : 0.5,
                px: isMobileViewport ? 1.1 : 1.4,
                textTransform: "none",
              }}
            >
              <Iconify icon="mdi:view-grid-outline" width={17} />
              {!isMobileViewport ? "Karten" : null}
            </ToggleButton>
          </ToggleButtonGroup>

          <Autocomplete
            multiple
            size="small"
            disableCloseOnSelect
            options={categoryOptions}
            value={selectedCategories}
            onChange={(_, nextValue) => onCategoryChange(nextValue || [])}
            disabled={!categoryOptions.length}
            clearOnEscape
            renderInput={(params) => (
              <TextField
                {...params}
                label="Kategorien filtern"
                placeholder="Alle Kategorien"
              />
            )}
            noOptionsText="Keine Kategorien vorhanden"
            sx={{ width: { xs: "100%", sm: 280 } }}
          />
        </Stack>
      ) : null}
    </Box>
  );
}
